import { alwaysDeleteElement, ElementModel } from "./element.model";
import { ClassEnum } from "../../_enum/form/class.enum";
import { ColumnArray } from "../../_enum/form/column.enum";

/** properties to always delete from an array when saving */
export const alwaysDeleteSubForm = [ ...alwaysDeleteElement ];

/**
 * A model for the structural form element: FormArrays
 */
export class SubFormModel extends ElementModel {

  constructor(model?: Partial<SubFormModel | any>) {
    super();
    this.overwrite(model);
    this.class = ClassEnum.Form;
  }

  public overwrite(model: Partial<any>, ...exclude: string[]) {
    super.overwrite(model, 'class', ...alwaysDeleteSubForm, ...exclude);
    if (!this.width) this.width = ColumnArray[ColumnArray.length - 1];
  }
}
